import { SeVaporOptions, SeEnvironment } from "@/types";
import { AppLocation } from "@/types/enums";

const SE_ENVIRONMENTS: readonly SeEnvironment[] = [
    "production",
    "staging",
    "development",
    "qa",
    "local",
] as const;

export const isSeEnvironment = (value: unknown): value is SeEnvironment =>
    typeof value === "string" &&
    (SE_ENVIRONMENTS as readonly string[]).includes(value);

export const validateDisplayOptions = (options: SeVaporOptions): void => {
    if (
        options.rentalApp?.location === AppLocation.EXTERNAL &&
        !options.rentalApp.externalUrl
    ) {
        throw new Error(
            "When 'rentalApp.location' is 'external', 'rentalApp.externalUrl' must be provided.",
        );
    }

    if (
        options.reservationApp?.location === AppLocation.EXTERNAL &&
        !options.reservationApp.externalUrl
    ) {
        throw new Error(
            "When 'reservationApp.location' is 'external', 'reservationApp.externalUrl' must be provided.",
        );
    }

    if (
        options.softReservationApp?.location === AppLocation.EXTERNAL &&
        !options.softReservationApp.externalUrl
    ) {
        throw new Error(
            "When 'softReservationApp.location' is 'external', 'softReservationApp.externalUrl' must be provided.",
        );
    }
};
